import { Controller } from "@hotwired/stimulus"
import { monitorAction, monitorError } from "../lib/datadog_monitoring"

// Connects to data-controller="photo-select"
export default class extends Controller {
  connect() {
    const firstPhoto = document.querySelector("[data-controller='photo-select']")
    if (firstPhoto === this.element) {
      monitorAction("job_post.photo_picker.initialized", {
        pathname: window.location.pathname
      })
    }
  }

  selectPhoto() {
    const allPhotos = document.querySelectorAll("[data-controller='photo-select']")
    const selectedPhoto = this.element
    const photoId = selectedPhoto.id.replace("picture_", "")

    const photoIdField = document.querySelector("[id$='photo_id']")
    if (!photoIdField) {
      monitorError("Photo picker could not find photo_id field", {
        pathname: window.location.pathname,
        selected_photo_id: photoId
      })
      return
    }

    photoIdField.value = photoId

    allPhotos.forEach(photo => {
      const checkmark = photo.querySelector(".checkmark")
      const image = photo.querySelector("img")

      if (!checkmark || !image) return

      if (photo === selectedPhoto) {
        photo.classList.add("bg-blue-600")
        image.classList.add("opacity-75")
        checkmark.classList.remove("hidden")
      } else {
        photo.classList.remove("bg-blue-600")
        image.classList.remove("opacity-75")
        checkmark.classList.add("hidden")
      }
    })

    monitorAction("job_post.photo_picker.photo_selected", {
      pathname: window.location.pathname,
      selected_photo_id: photoId
    })
  }
}
